import React, { useContext, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
    MainContainer,
    CheckedMessageBox,
    StyledTickImg,
    PriceOverrideAlert,
    EmailStyledDiv,
    SubContainer,
    Container,
} from '../components/submissionComplete.styled';
import CheckSubUsage from 'src/assets/images/CheckSubUsage.svg';
import {
    setSendReportModalState,
    setOrderStatus,
    setOrderSummaryModalState,
    getOrderSummaryData,
    showHideViewReportAction,
    showHideSendReportAction,
    resetViewPdfReport,
} from 'src/pages/orders/redux/actions';
import {
    vendorCaseIdMsgTemplate,
    logErrorToConsole,
    redirectToInitialPath,
} from 'src/utils/util';
import AlertMsg from 'src/pages/reportUsage/common/AlertMsg';
import SubmitScreenCTAbuttonsContainer from '../components/SubmitScreenCTAbuttonsContainer';
import SendUsageReport from 'src/pages/orders/components/reportsAndInvoice/sendUsageReport/SendUsageReport';
import SubmitCompletionCard from '../components/SubmitCompletionCard';
import { sizes } from 'src/styles/Media.styled';
import ViewReport from 'src/pages/orders/components/reportsAndInvoice/viewReport/ViewReport';
import { useTranslation } from 'react-i18next';
import { unlockOrderFunc } from 'src/pages/reportUsage/redux/saga/dataServices';
import { ReportUsageContext } from 'src/pages/reportUsage';
import {
    fetchUsageDetailsRequest,
    getOrderStatusDetails,
    setSubmitClicked,
} from '../../redux/action/actionCreators';
import { resetNotes } from 'src/common/redux/actions';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const SubmissionViewContainer = ({
    isFromOrderDetailsModal,
    usageOrderSubmission,
    reportUsageFormObj,
    fromOrdersList,
    resetReportUsageData,
    resetReportUsageStates,
    isNoUsageSubmitPage,
    onCTAButtonClick,
    noUsageMyCaseRefId,
    noUsageSubmittedMessage,
    myCaseResourceType,
    cancelSurgeryData,
    cancelReason,
    emails,
    vendorCaseErrorRedirection,
    isSubmitClicked,
    setCurrentActivity,
}) => {
    const dispatch = useDispatch();
    const history = useHistory();
    
    // Detect if page was refreshed - check only once on mount
    const isPageRefresh = useMemo(() => {
        if (typeof window !== 'undefined' && window.performance) {
            const navEntries = performance.getEntriesByType('navigation');
            if (navEntries.length > 0) {
                return navEntries[0].type === 'reload';
            }
        }
        return false;
    }, []);
    const { t } = useTranslation();
    const orderStatus = useSelector(
        (state) => state.reportUsageRootReducer.orderStatus
    );

    const restrictReviewScreen = useSelector(
        (state) => state.reportUsageRootReducer.restrictReviewScreen
    );
    const statusMessage = useSelector(
        (state) =>
            state.reportUsageRootReducer?.usageOrderSubmission?.statusMessage
    );

    const isUsagedSubmittedSuccessfully =
        (usageOrderSubmission && usageOrderSubmission.statusCode === '200') ||
        (Object.keys(orderStatus).length > 0 &&
            orderStatus.status &&
            orderStatus.status.includes('Usage Order Submitted Successfully'));
    const surgeryRefId = useSelector(
        (state) => state.reportUsageRootReducer.myCaseRefId
    );
    const myCaseRefId = surgeryRefId
        ? surgeryRefId
        : history.location.pathname.length > 12 &&
          history.location.pathname.replace('/reportUsage/', '');
    const reportSelector = useSelector(
        (state) => state.orderSummaryReducer.sendReportModal
    );

    const discrepencyUpdatedDetails = useSelector(
        (state) => state.reportUsageRootReducer.discrepencyUpdatedDetails
    );

    const [vendorCaseErrorDetails, setVendorCaseErrorDetails] = useState({});

    const redirectToOrders = (isCTAbuttonClicked) => {
        const redirectPath = redirectToInitialPath(history);
        history.push({
            ...redirectPath,
        });
        (myCaseRefId && myCaseRefId?.length > 0) && unlockOrderFunc({
            action:
                myCaseResourceType === 'reportPayment'
                    ? 'ReportPayment'
                    : myCaseResourceType === 'draft'
                    ? 'DraftUsageEdit'
                    : 'ReportUsage',
            myCaseRefId: myCaseRefId,
        });
        resetReportUsageData();
        resetReportUsageStates();
        dispatch(resetNotes());
        if (isFromOrderDetailsModal) {
            if (!isCTAbuttonClicked) {
                dispatch(setOrderStatus({ orderStatus: '' }));
                dispatch(getOrderSummaryData());
            }
            dispatch(
                setOrderSummaryModalState({
                    myCaseRef: myCaseRefId,
                    orderSummaryModal: isCTAbuttonClicked ? false : true,
                })
            );
        }
        localStorage.removeItem('myCaseRefUsage');
    };

    const sendUsageReportClickHandler = () => {
        if (reportSelector === false) {
            dispatch(
                setSendReportModalState({
                    showModal: true,
                    myCaseRefId: myCaseRefId,
                    isUsageReportOrderListPage: true,
                    isUsageReportSearchListPage: false,
                })
            );
            if (
                myCaseResourceType === 'reportPayment' &&
                usageDetails?.discrepancyExists
            ) {
                dispatch(
                    fetchUsageDetailsRequest({
                        resourceType: 'reportPayment',
                        myCaseRef: myCaseRefId,
                        isDiscrepencyCheck: true,
                    })
                );
            }
        }
    };
    const { viewReportOpen } = useSelector((state) => state.viewReportReducer);

    const onCloseViewReportHandler = () => {
        dispatch(showHideSendReportAction({ sendReportModal: true }));
        dispatch(
            showHideViewReportAction({
                viewReportOpen: false,
                viewReportBackNavigate: '',
            })
        );
        dispatch(resetViewPdfReport());
    };

    const onCloseViewReportIconHandler = () => {
        dispatch(
            showHideViewReportAction({
                viewReportOpen: false,
                viewReportBackNavigate: '',
            })
        );
        dispatch(
            setSendReportModalState({
                showModal: false,
                myCaseRefId: '',
                isUsageReportOrderListPage: false,
                isUsageReportSearchListPage: false,
            })
        );
        dispatch(resetViewPdfReport());
    };
    const { usageDetails } = useContext(ReportUsageContext);

    useEffectWithErrorLogging(() => {
        if (myCaseResourceType !== 'reportPayment' && !restrictReviewScreen) {
            dispatch(getOrderStatusDetails(isNoUsageSubmitPage ? noUsageMyCaseRefId : myCaseRefId));
            window.onload = function (e) {
                dispatch(getOrderStatusDetails(isNoUsageSubmitPage ? noUsageMyCaseRefId : myCaseRefId));
                e.preventDefault();
            };
        }
    }, []);

    useEffectWithErrorLogging(() => {
        if (
            usageOrderSubmission &&
            (usageOrderSubmission.statusCode === '11908' ||
                usageOrderSubmission.statusCode === '11909') &&
            (usageOrderSubmission.statusMessage ||
                usageOrderSubmission.statusDescription)
        ) {
            const vendorErrorDetails = vendorCaseIdMsgTemplate(
                usageOrderSubmission.statusMessage ||
                    usageOrderSubmission.statusDescription,
                usageOrderSubmission.statusCode
            );
            setVendorCaseErrorDetails(vendorErrorDetails);
        }
        // Block this condition when user refreshes the page
        if (
           // !isPageRefresh &&
            (usageOrderSubmission ||
            (Object.keys(orderStatus).length > 0 &&
                orderStatus.status &&
                orderStatus.status.includes(
                    'Usage Order Submitted Successfully'
                )))
        ) {
            dispatch(setSubmitClicked(false));
        }
    }, [usageOrderSubmission, orderStatus]);
    return (
        <>
            <MainContainer>
                <SubmitCompletionCard
                    isUsagedSubmittedSuccessfully={
                        isUsagedSubmittedSuccessfully ||
                        (isSubmitClicked && !restrictReviewScreen)
                    }
                    myCaseRefId={
                        isNoUsageSubmitPage ? noUsageMyCaseRefId : myCaseRefId
                    }
                    redirectToOrders={
                        isNoUsageSubmitPage
                            ? onCTAButtonClick
                            : redirectToOrders
                    }
                    isNoUsageSubmitPage={isNoUsageSubmitPage}
                    cancelSurgeryData={cancelSurgeryData}
                    cancelReason={cancelReason}
                    isReportPayment={myCaseResourceType === 'reportPayment'}
                    isSubmitClicked={isSubmitClicked}
                    setCurrentActivity={setCurrentActivity}
                />

                {(usageOrderSubmission &&
                    usageOrderSubmission.statusCode !== '200' &&
                    usageOrderSubmission.statusCode !== '11908' &&
                    usageOrderSubmission.statusCode !== '11909' &&
                    (usageOrderSubmission.statusMessage ||
                        usageOrderSubmission.statusDescription)) ||
                (Object.keys(orderStatus).length > 0 &&
                    orderStatus.status &&
                    orderStatus.status !== 'orderProcessing' &&
                    !orderStatus.status.includes(
                        'Usage Order Submitted Successfully'
                    )) ? (
                    <CheckedMessageBox checkedBoxMobileMargin={'0 0 32px 25px'}>
                        {usageOrderSubmission?.statusMessage ||
                            usageOrderSubmission?.statusDescription ||
                            orderStatus.status}
                    </CheckedMessageBox>
                ) : null}
                {vendorCaseErrorDetails?.templateMsg && (
                    <CheckedMessageBox
                        checkedBoxMobileMargin={'0 0 32px 25px'}
                        display={'inline-block'}
                    >
                        {`${vendorCaseErrorDetails.templateMsg}`}
                        {vendorCaseErrorDetails?.linkedSstRef && (
                            <span
                                id={`vendor-case-ref-${vendorCaseErrorDetails.linkedSstRef}`}
                                onClick={() => {
                                    try {
                                    vendorCaseErrorRedirection(
                                        vendorCaseErrorDetails.linkedSstRef,
                                        false,
                                        false
                                    );
                                 } catch (error) {
                                   logErrorToConsole(error);
                                 }
                                }}
                                style={{
                                    color: '#1010EB',
                                    fontSize: '15px',
                                    cursor: 'pointer',
                                }}
                            >
                                {`${vendorCaseErrorDetails.linkedSstRef}`}
                            </span>
                        )}
                    </CheckedMessageBox>
                )}
                {isUsagedSubmittedSuccessfully && (
                    <>
                        <CheckedMessageBox
                            checkedBoxMobileMargin={'0 0 32px 25px'}
                        >
                            {myCaseResourceType !== 'reportPayment' && (
                                <div style={{ display: 'flex' }}>
                                    <StyledTickImg
                                        src={CheckSubUsage}
                                        mbMarginRight={'18px'}
                                    />
                                    <span>
                                        {isNoUsageSubmitPage
                                            ? noUsageSubmittedMessage
                                            : myCaseResourceType ===
                                              'reportPayment'
                                            ? t('reportUsage.progressBar.Purchasesubmitted')
                                            : t('reportUsage.progressBar.Usagesubmitted')}
                                    </span>
                                </div>
                            )}
                            {(usageOrderSubmission &&
                                usageOrderSubmission.statusMessage &&
                                usageOrderSubmission.statusMessage.includes(
                                    'Replenishment requested'
                                )) ||
                            (Object.keys(orderStatus).length > 0 &&
                                orderStatus.status &&
                                orderStatus.status.includes(
                                    'Replenishment requested'
                                )) ? (
                                <div
                                    style={{
                                        display: 'flex',
                                        paddingTop: '10px',
                                    }}
                                >
                                    <StyledTickImg
                                        src={CheckSubUsage}
                                        mbMarginRight={'18px'}
                                    />
                                    <span>
                                        {t('reportUsage.submit.replenishmentReq')}
                                    </span>
                                </div>
                            ) : null}
                            {discrepencyUpdatedDetails?.discrepancyExists &&
                                emails?.length > 0 && (
                                    <Container>
                                        <StyledTickImg
                                            src={CheckSubUsage}
                                            mbMarginRight={'18px'}
                                            marginTop={'5px'}
                                        />
                                        <SubContainer>
                                            <span>
                                                {t('reportUsage.submit.discrepancyRep')}
                                            </span>
                                            <EmailStyledDiv>
                                                <span className="report-usage-account-address-dt-mask">{emails?.join(', ')}</span>
                                            </EmailStyledDiv>
                                        </SubContainer>
                                    </Container>
                                )}
                        </CheckedMessageBox>
                        {(usageOrderSubmission &&
                            usageOrderSubmission.statusMessage &&
                            usageOrderSubmission.statusMessage.includes(
                                'Price override requested'
                            )) ||
                        (Object.keys(orderStatus).length > 0 &&
                            orderStatus.status &&
                            orderStatus.status.includes(
                                'Price override requested'
                            )) ? (
                            <>
                                <PriceOverrideAlert
                                    alertMessageMobileMargin={'0 0 10px 25px'}
                                >
                                    <AlertMsg
                                        message={
                                            t('reportUsage.submit.alertMsg')
                                        }
                                        mbFontSize={'15px'}
                                        mbHeight={
                                            window.innerWidth <=
                                                sizes.mobileDevice && '18px'
                                        }
                                        mbWidth={
                                            window.innerWidth <=
                                                sizes.mobileDevice && '18px'
                                        }
                                        marginLeft={'0px'}
                                        
                                    />
                                </PriceOverrideAlert>
                                <PriceOverrideAlert
                                    alertMessageMobileMargin={'0 0 10px 25px'}
                                >
                                    <AlertMsg
                                        message={
                                            t('reportUsage.submit.alertMsg1')
                                        }
                                        mbFontSize={'15px'}
                                        mbHeight={
                                            window.innerWidth <=
                                                sizes.mobileDevice && '18px'
                                        }
                                        mbWidth={
                                            window.innerWidth <=
                                                sizes.mobileDevice && '18px'
                                        }
                                        marginLeft={'0px'}
                                    />
                                </PriceOverrideAlert>
                            </>
                        ) : null}
                        {discrepencyUpdatedDetails?.discrepancyExists && (
                            <PriceOverrideAlert
                                alertMessageMobileMargin={'0 0 10px 25px'}
                            >
                                <AlertMsg
                                    message={t(
                                        'reportUsage.discrpancyAlertMessage.ImportantDiscrepancyAlert'
                                    )}
                                    mbFontSize={'15px'}
                                    mbHeight={
                                        window.innerWidth <=
                                            sizes.mobileDevice && '18px'
                                    }
                                    mbWidth={
                                        window.innerWidth <=
                                            sizes.mobileDevice && '18px'
                                    }
                                
                                />
                            </PriceOverrideAlert>
                        )}
                    </>
                )}
                <SubmitScreenCTAbuttonsContainer
                    sendUsageReportClickHandler={sendUsageReportClickHandler}
                    redirectToOrders={redirectToOrders}
                    myCaseRefId={myCaseRefId}
                    reportUsageFormObj={reportUsageFormObj}
                    isNoUsageSubmitPage={isNoUsageSubmitPage}
                    onCTAButtonClick={isNoUsageSubmitPage && onCTAButtonClick}
                    fromOrdersList={fromOrdersList}
                    myCaseResourceType={myCaseResourceType}
                    isSubmitClicked={isSubmitClicked}
                />
            </MainContainer>
            {reportSelector && (
                <SendUsageReport reportSelector={reportSelector} />
            )}

            {viewReportOpen && (
                <ViewReport
                    onCloseViewReportHandler={onCloseViewReportHandler}
                    onCloseViewReportIconHandler={onCloseViewReportIconHandler}
                />
            )}
        </>
    );
};

export default SubmissionViewContainer;
